export * from './lib/last-updated-information.module';
export * from './lib/last-updated-information.component';
